import idlImport from './game.did.js';
export const idlFactory = idlImport;
export const canisterId = "flros-uqaaa-aaaah-aaiyq-cai";
